import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../environments/environment";
import { IEnvironment } from "../../app/app.model";


@Component({
  selector: "app-privacy-policy",
  imports: [CommonModule],
  templateUrl: "./privacy-policy.component.html",
  styleUrl: "./privacy-policy.component.css",
})
export class PrivacyPolicyComponent implements OnInit {

  lastUpdated: string;
  environment: IEnvironment = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute) {
    this.lastUpdated = new Date().toLocaleDateString();
  }

  ngOnInit(): void {}

   /**
   * When user clicks TOS on signup on PWA will be redirect to Angular TOS.
   * Return back to PWA on click back btn
   */
  goBack(): void {
    this.route.queryParamMap.subscribe(params => {
      const redirectBackTo = params.get('redirect-back-to');
      if (redirectBackTo && redirectBackTo == "app") {
        window.location.href = `${environment.PwaFrontendBaseUrl}/auth/signup`;
      } else {
        this.router.navigate([""]);
      }
      console.log("redirectBackTo: ", redirectBackTo);
    });
  }
}
